'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        fontSize: "14px",
        lineHeight: "16px",
        backgroundColor: variables.COLORS.WHITE,
        borderRadius: variables.SIZES.BORDER_RADIUS,
        "&:not($focused):not($error):not($disabled):hover $notchedOutline": {
            border: `solid 1px ${variables.COLORS.GREYSCALE_0_05}`,
            borderColor: variables.COLORS.GREYSCALE_0_30,
        },
        "&$focused:not($error) $notchedOutline": {
            border: `solid 1px ${variables.COLORS.MISC_FOCUS_BORDER}`,
            boxShadow: `0px 0px 0px 1px ${variables.COLORS.MISC_FOCUS_BORDER}, inset 0 2px 0 0 ${variables.COLORS.GREYSCALE_0_05}`,
        },
        "&$focused$error $notchedOutline": {
            border: `solid 1px ${variables.COLORS.RED}`,
            boxShadow: `0px 0px 0px 1px ${variables.COLORS.RED}, inset 0 2px 0 0 ${variables.COLORS.GREYSCALE_0_05}`,
        },
        "&$disabled": {
            backgroundColor: "transparent",
        },
        "&$disabled $notchedOutline": {
            border: `solid 1px ${variables.COLORS.GREYSCALE_0_10}`,
            borderColor: variables.COLORS.GREYSCALE_0_10,
            backgroundColor: variables.COLORS.GREYSCALE_0_05,
        },
    },
    adornedStart: {
        paddingLeft: 0,
    },
    adornedEnd: {
        paddingRight: 0,
    },
    input: {
        color: variables.COLORS.TEXT_PRIMARY,
        padding: "8px 12px",
        "&$disabled": {
            opacity: 0.45,
        },
    },
    notchedOutline: {
        borderColor: variables.COLORS.GREYSCALE_0_15,
        borderRadius: variables.SIZES.BORDER_RADIUS,
        boxShadow: `inset 0 2px 0 0 ${variables.COLORS.GREYSCALE_0_05}`,
    },
    multiline: {
        padding: "8px 12px",
    },
};

var MuiOutlinedInput = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiOutlinedInput = MuiOutlinedInput;
exports.light = light;
